import {useQuery} from '@tanstack/react-query'
import {startOfToday} from 'date-fns'

import {
    type AssignmentStripDateRangeOptions,
    DEFAULT_ASSIGNMENT_STRIP_DATE_RANGE,
    formatAssignmentStripDateRange,
} from 'src/assignments/assignment-strip-utils'

import {listRentalAssetAssignments} from './api'
import {rentalAssetKeys} from './query-keys'

type UseRentalAssetAssignmentsOptions = {
    enabled?: boolean
    referenceDate?: Date
    dateRange?: AssignmentStripDateRangeOptions
}

export function getRentalAssetAssignmentDateRange(
    referenceDate: Date = startOfToday(),
    dateRange: AssignmentStripDateRangeOptions = DEFAULT_ASSIGNMENT_STRIP_DATE_RANGE,
) {
    return formatAssignmentStripDateRange(referenceDate, dateRange)
}

export function useRentalAssetAssignments(
    assetId: string,
    options?: UseRentalAssetAssignmentsOptions,
) {
    const {
        enabled = true,
        referenceDate: referenceDateOption,
        dateRange = DEFAULT_ASSIGNMENT_STRIP_DATE_RANGE,
    } = options ?? {}
    const {dateFrom, dateTo, referenceDate} = getRentalAssetAssignmentDateRange(
        referenceDateOption ?? startOfToday(),
        dateRange,
    )

    const query = useQuery({
        queryKey: rentalAssetKeys.assignments(assetId, dateFrom, dateTo),
        queryFn: () => listRentalAssetAssignments(assetId, {dateFrom, dateTo}),
        enabled: enabled && Boolean(assetId),
    })

    return {...query, referenceDate, dateRange}
}
